import Component from '@glimmer/component';
import type { ColumnHeader } from 'garaje/components/ui/table';
import type { DeskInventoryModel } from 'garaje/pods/resources/resource-type/index/route';

interface DeskInventoryListComponentArgs {
  model: DeskInventoryModel;
}

export default class DeskInventoryListComponent extends Component<DeskInventoryListComponentArgs> {
  get columns(): ColumnHeader[] {
    return [
      {
        key: 'floor',
        label: 'Floor',
        sortable: true,
      },
      {
        key: 'name',
        label: 'Name',
        sortable: true,
      },
      {
        key: 'enabled',
        label: 'Enabled',
        sortable: true,
      },
      {
        key: 'neighborhood',
        label: 'Neighborhood',
        sortable: true,
      },
      {
        key: 'amenities',
        label: 'Amenities',
        sortable: false,
      },
      {
        key: 'assignedTo',
        label: 'Assigned to',
        sortable: true,
      },
    ];
  }
}
